import { useContext } from 'react';

import {
  BreadcrumbsContext,
  type IBreadcrumbContextData,
} from '../contexts/breadcrumbs';

export const useBreadcrumbs = (): IBreadcrumbContextData =>
  useContext(BreadcrumbsContext);
